import { render } from "./DatosPersonales.vue?vue&type=template&id=65289830&scoped=true"
import script from "./DatosPersonales.vue?vue&type=script&lang=js"
export * from "./DatosPersonales.vue?vue&type=script&lang=js"

import "./DatosPersonales.vue?vue&type=style&index=0&id=65289830&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65289830"]])

export default __exports__